import {Component, Input, OnInit} from '@angular/core';
import {MultiSelectComponent} from '../multi-select.component';
import {LanguagesService} from '../../../../core';

@Component({
  selector: 'gc-multi-select-detail',
  templateUrl: './multi-select-detail.component.html',
  styleUrls: ['./multi-select-detail.component.css']
})
export class MultiSelectDetailComponent implements OnInit {

  constructor(public lang: LanguagesService) { }

  @Input() parent: MultiSelectComponent;
  ngOnInit(): void {
  }

}
